/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */
import React from "react";
import ReactDOM from "react-dom";
import Root from "./components/application/Root";
import * as serviceWorker from "./serviceWorker";
// import './FontAwesomeIcons';
import "./sass/main.scss";
import { getHistory } from "./core/modules/common/tools/HistoryTools";
import config from "./core/config/configureSettings";
import {
  defaultLanguage,
  supportedLanguages,
} from "./core/modules/common/tools/Internationalization";
import configureStore from "./core/store";

const history = getHistory();
const initialPath = history.getCurrentLocation().pathname;
let languageFromHistory =
  initialPath.replace(config.basePath, "").split("/")[0] || defaultLanguage;
if (supportedLanguages.indexOf(languageFromHistory) === -1)
  languageFromHistory = defaultLanguage;

const store = configureStore({
  global: {
    locales: {
      lang: languageFromHistory,
      messages: {
        // eslint-disable-next-line global-require,import/no-dynamic-require
        ...require(`./locales/${languageFromHistory}.js`).default.messages,
        // eslint-disable-next-line global-require,import/no-dynamic-require
        ...require(`../src/locales/${languageFromHistory}.js`).default.messages,
      },
    },
  },
});

export default ReactDOM.render(
  <Root store={store} />,
  document.getElementById("root") || document.createElement("div")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
